import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import LabelItem, { LabelItemProps } from 'components_new/molecules/LabelItem'
import ValueText, { ValueTextProps } from 'components_new/molecules/ValueText'

type LabelItemContentProps = Omit<LabelItemProps, 'children'> & {
  content: LabelItemProps['children']
}

export interface MetaRowProps {
  items?: (LabelItemContentProps | ValueTextProps)[]
  sx?: SxProps
}

const MetaRow = (props: MetaRowProps) => {
  const { items, sx } = props

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, ...sx }}>
      {items?.map((item, i) => {
        if ('value' in item) {
          return <ValueText key={i} {...item} />
        }

        const { content, ...rest } = item

        return (
          <LabelItem key={i} {...rest}>
            {content}
          </LabelItem>
        )
      })}
    </Box>
  )
}

export default MetaRow
